module.exports = __webpack_public_path__ + "img/SirGauywneWete.d37f388d.png";